package dev.codetwister.ctdev

import androidx.compose.foundation.Image
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.tooling.preview.Devices
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import ctdev.composeapp.generated.resources.Res
import ctdev.composeapp.generated.resources.webctbg
import org.jetbrains.compose.resources.painterResource

@Composable
@Preview(device = Devices.DESKTOP)
fun App() {
    MaterialTheme(
        colorScheme = darkColorScheme(
            background = BgDark,
            surface = BgCard,
            primary = Green,
            onBackground = TextPrimary,
            onSurface = TextPrimary,
        ),
    ) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center,
        ) {
            Image(
                painter = painterResource(Res.drawable.webctbg),
                contentDescription = null,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Crop,
            )
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .horizontalScroll(rememberScrollState())
                    .verticalScroll(rememberScrollState()),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(40.dp, Alignment.CenterVertically),
            ) {
                Row(
                    modifier = Modifier
                        .wrapContentSize()
                        .padding(top = 40.dp, start = 40.dp, end = 40.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(80.dp, Alignment.CenterHorizontally),
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(40.dp, Alignment.CenterVertically),
                    ) {
                        HeroSection()
                        FooterLinks()
                    }
                    PhoneMockup(
                        modifier = Modifier.width(240.dp).height(500.dp),
                    )
                }
                FooterNote(
                    modifier = Modifier.padding(bottom = 40.dp),
                )
            }
        }
    }
}
